import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import Image from './_image.js'
import DateTime from './_date-time.js'

export default {
  name: 'BonusCard',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          minHeight: '85px',
          padding: '8px',
        },
      },
    },
    headerContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          padding: '0 0 16px 0',
          flexDirection: 'column',
        },
      },
    },
    nameAndStatusContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          height: '20px',
          alignItems: 'center',
        },
      },
    },
    headerText: {
      configSet: Text,
      configValues: {
        truncate: true,
      },
    },
    statusText: {
      configSet: Text,
      configValues: {
        style: {
          textAlign: 'right',
        },
      },
    },
    prewagerIcon: {
      configSet: Image,
      configValues: {
        src: 'prewager',
        style: {
          width: '16px',
          height: '16px',
          padding: '0px 4px 0 0px',
        },
      },
    },
    cashIcon: {
      configSet: Image,
      configValues: {
        src: 'cash',
        style: {
          width: '16px',
          height: '16px',
          padding: '0px 4px 0 0px',
        },
      },
    },
    oddsBoostIcon: {
      configSet: Image,
      configValues: {
        src: 'promotion-boost',
        style: {
          width: '16px',
          height: '16px',
          padding: '0px 4px 0 0px',
        },
      },
    },
    freeBetIcon: {
      configSet: Image,
      configValues: {
        src: 'freebet-filled',
        style: {
          width: '16px',
          height: '16px',
          padding: '0px 4px 0 0px',
        },
      },
    },
    expireDateText: {
      configSet: Text,
      configValues: {
        container: {
          alignItems: 'center',
        },
      },
    },
    expireDateFormat: {
      configSet: DateTime,
      configValues: {
        format: 'NUMERIC_DATE_TIME',
      },
    },
    bonusDescriptionText: {
      configSet: Text,
      configValues: {},
    },
    descriptionContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          _mobile_flexDirection: 'column',
          padding: '0 0 2px 0',
        },
      },
    },
    progressBarContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          minWidth: '30%',
          _desktop_padding: '0 0 0 16px',
          _mobile_padding: '8px 0 8px',
        },
      },
    },
    amountContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    amountText: {
      configSet: Text,
      configValues: {
        style: {
          textAlign: 'end',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
